import type { ReactNode } from 'react';
import { RequireRole } from './RequireRole';

/**
 * Internal pages (B3-theme): open in development, super admin only in a
 * built app. RequireRole with no role admits the super admin alone and sends
 * the others to /unauthorized (or /Login without a session).
 */
export function DevOrSuperAdmin({ children, isDev = import.meta.env.DEV }: { children: ReactNode; isDev?: boolean }) {
  if (isDev) return <>{children}</>;
  return <RequireRole roles={[]}>{children}</RequireRole>;
}
